import { render, staticRenderFns } from "./roomMatch.vue?vue&type=template&id=6ea6ede2&lang=pug&"
import script from "./roomMatch.vue?vue&type=script&lang=js&"
export * from "./roomMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports